module.exports = __webpack_public_path__ + "static/media/organization_dynamo.3a287d27.svg";